import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utils';

// Fetch billing info directly from backend
export const fetchBillingInfo = createAsyncThunk(
    'getBillingInfo',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiFetch('api/t/billing');

            return await response.json();
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const billingSlice = createSlice({
    name: 'billing',
    initialState: {
        logs: [],
        balance: 0,
        loading: false,
        error: null,
    },
    reducers: {
        addLog: (state, action) => {
            state.logs.unshift(action.payload);
        },
        clearLogs: (state) => {
            state.logs = [];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBillingInfo.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBillingInfo.fulfilled, (state, action) => {
                state.loading = false;
                state.logs = action.payload?.logs?.reverse() || [];
                state.balance = action.payload?.balance || -1;
            })
            .addCase(fetchBillingInfo.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to load billing info';
                state.balance = -1;
            });
    },
});

export default billingSlice.reducer;
